import React, { FC } from 'react';
import { ConsumerMessage } from '../../message/message.types';
import { convertDateToNeedFormat } from '../../../utils/convertDateHandlers';
import { toIsoDateTime } from '../../../utils/parseServerDate';
import cls from './ChatMessage.module.scss';
import { IoCheckmarkSharp, IoCheckmarkDoneSharp } from 'react-icons/io5';
import ChatFileItem from '../ChatFileItem';

type ChatMessageProps = {
  message: ConsumerMessage;
  consumerEmail: string;
  consumerName: string;
};

const ChatMessage: FC<ChatMessageProps> = ({ message, consumerName }) => {
  if (message.author === 'CONSUMER') {
    return (
      <div className={cls.Message} data-testid="message-container">
        <div className={cls.ConsumerMessage}>
          <h6 className={cls.ConsumerName}>{consumerName}</h6>
          {message.fileInfo && message.fileInfo.fullName && (
            <div className={cls.FileMessage}>
              {message.fileInfo && message.fileInfo.fullName && (
                <ChatFileItem file={message.fileInfo} isConsumer={true} />
              )}
              <div className={cls.Time} data-testid="message-time">
                <time dateTime={toIsoDateTime(message.createdAt) ?? undefined} className={cls.Time}>
                  {convertDateToNeedFormat({ date: message.createdAt, format: 'time' })}
                </time>
              </div>
            </div>
          )}
          {message.text && !message.fileInfo && (
            <div className={cls.Text}>
              <p className={cls.MessageText}>{message.text}</p>
              <time dateTime={toIsoDateTime(message.createdAt) ?? undefined} className={cls.Time}>
                {convertDateToNeedFormat({ date: message.createdAt, format: 'time' })}
              </time>
            </div>
          )}
        </div>
      </div>
    );
  }
  // a system message shares the support layout, but is marked with a badge and a dark bubble
  const isSystem = message.author === 'SYSTEM';
  const bubbleClass = isSystem ? cls.SystemMessage : cls.SupportMessage;
  const timeClass = `${cls.Time} ${isSystem ? cls.SystemTime : cls.SupportTime}`;
  return (
    <>
      <div className={cls.Message} data-testid="message-container">
        <div className={bubbleClass}>
          {isSystem && (
            <h6 className={cls.SystemBadge} data-testid="message-system-badge">
              SYSTEM
            </h6>
          )}
          {message.fileInfo && message.fileInfo.fullName && (
            <div className={cls.FileMessage}>
              {message.fileInfo && message.fileInfo.fullName && (
                <ChatFileItem file={message.fileInfo} isConsumer={false} />
              )}
              <div className={timeClass}>
                <time
                  dateTime={toIsoDateTime(message.createdAt) ?? undefined}
                  data-testid="message-time"
                >
                  {convertDateToNeedFormat({ date: message.createdAt, format: 'time' })}
                </time>
                {message.status === 'SENT' && <IoCheckmarkSharp />}
                {message.status === 'READ' && <IoCheckmarkDoneSharp />}
              </div>
            </div>
          )}
          {message.text && !message.fileInfo && (
            <div className={cls.Text}>
              <p className={cls.MessageText} data-testid="message-text">
                {message.text}
              </p>
              <div className={timeClass}>
                <time
                  dateTime={toIsoDateTime(message.createdAt) ?? undefined}
                  data-testid="message-time"
                >
                  {convertDateToNeedFormat({ date: message.createdAt, format: 'time' })}
                </time>
                {message.status === 'SENT' && <IoCheckmarkSharp />}
                {message.status === 'READ' && <IoCheckmarkDoneSharp />}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ChatMessage;
